import { useWillowThemeContext } from '@branch-messenger/willow-ui'
import { router } from '@lib/router'
import { RouterProvider } from '@tanstack/react-router'

export const App = () => {
  const { setTheme } = useWillowThemeContext()
  return <RouterProvider router={router} context={{ setTheme }} />
}
